import React from 'react'
import './sign-up.scss'
import Dropdown from '../../common/dropdown/dropdown'
import DropdownV2 from '../../common/dropdown-v2/dropdown'
import { Constants, ImageConstants } from '../../../constants/constants'
import CommonUtils from '../../../utility/common-utilities'
import { getImageSource } from '../../../utility/image-source'
import PillButtonSelect from '../../common/pill-button-select/pill-button-select'
import { Modal, ModalBody } from 'reactstrap'
import SchoolUserApi from '../../../apis/student'
import SchoolApi from '../../../apis/school'
import Path from '../../routes/routes-path'
const SALUTATIONS = [{ title: "Mr.", value: "Mr." }, { title: "Mrs.", value: "Mrs." }, { title: "Miss", value: "Miss" }]
class SchoolUserSignUp extends React.Component {
  constructor(props) {
    super(props)
    this.state.classDropDownData = this.props.classes
      ? JSON.parse(JSON.stringify(this.props.classes))
      : []
    this.state.rolesDropDownData = this.props.roles
      ? JSON.parse(JSON.stringify(this.props.roles))
      : []
    this.state.boardDropDownData = this.props.boards
      ? JSON.parse(JSON.stringify(this.props.boards))
      : []
    if (this.state.boardDropDownData.length === 1) this.state.board = this.props.boards[0].value
    this.state.countryCodeDropDownData = this.props.countries
      ? JSON.parse(JSON.stringify(this.props.countries))
      : []
    this.state.hashedCountryCode = this.props.hashedCountryCode
      ? JSON.parse(JSON.stringify(this.props.hashedCountryCode))
      : []

    this.state.type = this.getParameterByName(
      'type',
      this.props?.location?.search
    )
  }

  dropdown = []

  /**
   * Get respective params from the provided URL
   * @param {*} name - Param name
   * @param {*} url - Provided URL
   */
  getParameterByName = (name, url) => {
    if (url) {
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    return ''
  }

  componentDidMount() {

  }

  state = {
    schoolName: '',
    emailId: '',
    school: {},
    city: '',
    branch: '',
    boards: [],
    board: "",
    classes: [{ class: "", sections: [] }],
    sections: [],
    noSections : [],
    role: {},
    name: '',
    mobileNumber: '',
    countryCode: '+91',
    otp: '',
    salutation: 'Mr.',
    isInvalidEmail: false,
    isSubmit: false,
    isOtpSubmit: false,
    isInvalidClass: false,
    isInvalidBoard: false,
    otpSend: false,
    isEmailAlreadyRegistered: false,
    isInvalidOTP: false,
    isExpiredOTP: false,
    isValidForm: false,
    isSignupSuccess: false,
    noSectionInClass : false,

    showRemoveButton: false,
    hoverIndex: -1
  }

  addNewClass = _ => {
    const { classes, noSectionInClass } = this.state
    classes.push({ class: "", sections: [] })
    this.setState({ classes, noSectionInClass : false })
  }

  removeClass = index => {
    let { classes, noSectionInClass } = this.state
    classes.splice(index, 1)
    this.setState({ classes, noSectionInClass : false })
  }

  onChangeHandler = (event, key) => {
    this.setState({ [key]: event.target.value }, _ => {
      if (key === 'emailId') {
        this.setState({
          isEmailAlreadyRegistered: false,
          otpSend: false,
          isSubmit: false
        })
      }
      this.validatePayload()
    })
  }

  onSelect = (option, key) => {
    this.setState({ [key]: option?.value }, _ => {
      this.validatePayload()
      // console.log(this.state[key], key);
    })
  }


  onSelectRole = (option, key) => {
    this.setState({ [key]: option })
  }

  onSelectClass = (option, index) => {
    const { classes, boardDropDownData } = this.state
    classes[index].class = option?.value
    console.log(classes)
    this.setState({ classes, selectedClass : option?.value  }, _ => {
      this.getSections({ board: classes[index].board, class: option?.value }, index)
    })
  }

  onSelectBoard = (option, index) => {

    const { classes } = this.state
    classes[index].board = option?.value
    console.log(classes)
    this.setState({ classes, selectedBoard : option?.value }, _ => {
      if (classes[index].class) this.getSections({ board: option?.value, class: classes[index].class }, index)
    })
  }

  getSections(payload = {}, index) {

    console.log(index)


    if (!payload.class) return
    const { userDetails, boards } = this.props
    if (!payload.board) payload.board = boards[0].title
    payload.schoolId = userDetails.schoolCode
    SchoolApi.getSectionsPublic(payload)
      .then(response => {
        const { sections, classes } = this.state

        if(response.response[0].noSectionInClass) {

          classes[index].sections.push(response.response[0]._id)

          console.log(classes[index])


          // noSections.push({
          //     title: response.response[0].section,
          //     value: response.response[0]._id,
          // })
          this.setState({noSectionInClass : response.response[0].noSectionInClass })
        }else {
          console.log(classes[index])
          sections[index] = []
        for (let i = 0; i < response.response.length; i++) {
          //  if(!response.response[i].noSectionInClass) {
            sections[index].push({
              title: response.response[i].section,
              value: response.response[i]._id,
            })
          // }
          
        }

        }

        
        this.setState({ sections }, _ => {
          if (this.dropdown[index]) this.dropdown[index].resetDropdown()
        })
      }).catch(err => {
        console.log(err)
      })
  }

  onSelectSection = (options, index) => {
    const { classes } = this.state
    classes[index].sections = options.map(opt => opt.value)
    this.setState({ classes, selectedSections : options.map(opt => opt.value) })
  }

  onBlurEmailInput = event => {
    let value = event.target.value

    if (value) {
      let isValid = CommonUtils.validateEmail(event.target.value)
      if (!isValid)
        this.setState({ isInvalidEmail: true }, _ => {
          this.validatePayload()
        })
      else
        this.setState({ isInvalidEmail: false }, _ => {
          this.validatePayload()
        })
    } else {
      if (this.state.isInvalidEmail)
        this.setState({ isInvalidEmail: false }, _ => {
          this.validatePayload()
        })
    }
  }

  sendUsersSignupOTP = _ => {
    this.setState({ showError: true })
    let isValid = this.validatePayload()
    if (!isValid) return
    this.setState({ isSubmit: true })
    const { emailId, firstName, lastName, countryCode, mobileNumber, selectedBoard, selectedClass, selectedSections } = this.state
    let payload = {
      email: emailId,
      first_name: firstName,
      last_name: lastName,
      country_code: countryCode,
      mobile_number: mobileNumber,
      school_name: this.props.userDetails.schoolName,
      school_code: this.props.userDetails.schoolCode,
      sections : this.prepareSections()
    }

    SchoolUserApi.sendUsersSignupOTP(payload)
      .then(res => {
        if (res.status === 200) {
          this.setState({
            otpSend: true,
            isEmailAlreadyRegistered: false
          })
        }
      })
      .catch((err, res) => {
        if (err?.response?.data?.code === 11000) {
          this.setState({
            isEmailAlreadyRegistered: true
          })
        } else if (err?.response?.data?.message === 'Email already exist') {
          this.setState({
            isInvalidEmail: true
          })
        }
        this.setState({ isSubmit: false, isOtpSubmit: false })
      })
  }

//   [
//     {
//         "class": "Class 6",
//         "sections": [],
//         "board": "CBSE"
//     },
//     {
//         "class": "Class 7",
//         "sections": [
//             "63eefee78b1b8a88ec30e607"
//         ],
//         "board": "CBSE"
//     }
// ]


  prepareSections = _ => {
    const { classes } = this.state
    const sections = []
    classes.map(sc => {
        sc.sections.map(s => sections.push(s))
    })
    return sections
}

  signUp = () => {
    this.setState({ isSubmit: true, isOtpSubmit: true })
    let isValid = this.validatePayload(true)

    if (!isValid) return

    const {
      classes,
      role,
      firstName,
      lastName,
      countryCode,
      mobileNumber,
      landLine,
      emailId,
      otp,
      type,
    } = this.state
    let payload = {
      firstName,
      lastName,
      countryCode,
      mobileNumber,
      role,
      otp,
      landline: landLine,
      email: emailId,
      school_name: this.props.userDetails.schoolName,
      schoolId: this.props.userDetails.schoolCode,
      types: this.getTypes(),
      sections : this.prepareSections()
    }
    if (!type || type === 'teacher') payload.selectedClasses = classes
    SchoolUserApi.schoolUserSignup(payload)
      .then(res => {
        if (res.status === 200) {
          this.setState({
            isSignupSuccess: true
          })
          this.props.setSignupSuccess(firstName + " " + lastName)
        }
      })
      .catch((err, res) => {
        if (err?.response?.data?.message) {
          const message = err?.response?.data?.message
          if (message === 'Duplicate Email') {
            this.setState({
              isEmailAlreadyRegistered: true
            })
          } else if (message === 'Incorrect OTP') {
            this.setState({
              isInvalidOTP: true
            })
          } else if (message === 'OTP has expired') {
            this.setState({
              isExpiredOTP: true
            })
          } else if (message === 'No OTP found for given email') {
            this.setState({
              isInvalidOTP: true
            })
          }
        } else if (
          err?.response?.status === 901 &&
          err?.response?.data?.message
        ) {
          this.validatePayload()
        }
        this.setState({ isSubmit: false, isOtpSubmit: false })
      })

  }

  getTypes = _ => {
    const { type, role } = this.state
    if (type === "admin") {
      return [{ type: "ADMIN", displayType: "ADMIN" }]
    } else if (type === "management") {
      return [{ type: role.value, displayType: role.title }]
    } else {
      return [{ type: "MATH_TEACHER", displayType: "MATH TEACHER" }]
    }
  }

  validatePayload = isOTP => {
    this.setState({
      isValidForm: false
    })
    let countryCodeDetail = this.state.hashedCountryCode[this.state.countryCode]
    let validateCountryCode = CommonUtils.validateMobileNumber(
      this.state.mobileNumber,
      countryCodeDetail
    )
    if (!validateCountryCode) {
      this.setState({ isInvalidMobile: true })
      return false
    } else {
      this.setState({ isInvalidMobile: false })
    }
    if (this.state.type === "management" && !this.validateRole()) return false

    if (!this.state.salutation) return false
    if (!this.state.firstName || !this.state.lastName) return false
    if (!this.state.emailId || this.state.isInvalidEmail) return false
    if (!this.state.countryCode) return false
    if (!this.state.mobileNumber.trim()) return false
    //  if(!this.state.selectedBoard) return false
     if(!this.state.noSectionInClass) {
        if(!this.state.selectedSections) {
          return false
        }
     }
     
     
     
    // if(!this.state.selectedSections) return false
    if (isOTP && !this.state.otp) return false
    this.setState({
      isValidForm: true
    })
    return true
  }

  validateRole = () => {
    const { role } = this.state
    let isRoleSelected = true

    if (!role.value || !role.title) isRoleSelected = false

    if (!isRoleSelected) this.setState({ isInvalidRole: true })
    else this.setState({ isInvalidRole: false })

    if (!isRoleSelected) return false

    return true
  }

  onSelectPillButton = (response, key) => {
    const res = response.map(r => {
      let obj = {
        name: r
      }
      return obj
    })
    if (key === 'class') {
      this.setState(
        {
          classes: res
        },
        _ => {
          this.validateClass()
        }
      )
    } else if (key === 'board') {
      this.setState(
        {
          board: res
        },
        _ => {
          this.validateBoard()
        }
      )
    }
  }

  openPopup = _ => {
    this.setState({
      openPopup: true
    })
  }

  removeSignUpfailedAlert = () => {
    this.props.delegate &&
      this.props.delegate.removeSignUpFailedMessage &&
      this.props.delegate.removeSignUpFailedMessage()
  }

  onFocusEmailInput = () => {
    if (this.props.isEmailAlreadyRegistered)
      this.props.delegate &&
        this.props.delegate.disableEmailIdAlreadyInUseErrorMsg &&
        this.props.delegate.disableEmailIdAlreadyInUseErrorMsg()
  }

  render() {
    const {
      boardDropDownData,
      classDropDownData,
      rolesDropDownData,
      countryCodeDropDownData,
      isSubmit,
      isInvalidRole,
      countryCode,
      otpSend,
      firstName,
      lastName,
      role,
      classes,
      selectedBoard,
      selectedClass,
      selectedSections,
      landLine,
      salutation,
      mobileNumber,
      emailId,
      isInvalidEmail,
      isInvalidMobile,
      otp,
      isEmailAlreadyRegistered,
      isOtpSubmit,
      isInvalidOTP,
      isExpiredOTP,
      isSignupSuccess,
      showError,
      type
    } = this.state

    return (
      <div className='school-users-sign-up center-box'>
        <div className='cw-card'>
          <div className='cw-card-body'>
            {this.props.isSignUpfailed && (
              <div className='row sign-up-failed-alert-space'>
                <div className='col'>
                  <div className='sign-up-failed-alert'>
                    <div className='row signup-failed-height'>
                      <div className='col-10 display-flex-center'>
                        <div className='pl-4'>
                          Signup failed. Please Signup again
                        </div>
                      </div>
                      <div className='col-2 display-flex-center justify-center cursor-pointer'>
                        <img
                          src={getImageSource(ImageConstants.REMOVE_CIRCLE)}
                          onClick={this.removeSignUpfailedAlert}
                          className='remove-icon'
                        ></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!isSignupSuccess && (
              <>
                <div className='row'>
                  <div className='col'>
                    <label className='cw-input-label'>
                      NAME
                      <span className='star'>*</span>
                    </label>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <div
                      className='d-inline-block mr-2'
                      style={{ width: '15%' }}
                    >
                      <Dropdown
                        key='salutation'
                        placeholder='Mr.'
                        options={SALUTATIONS}
                        invalid={showError && !salutation}
                        onSelect={option =>
                          this.onSelect(option, 'salutation')
                        }
                        value={salutation}
                        style={{ background: '#F6F7F5' }}
                      />
                    </div>
                    <div className='d-inline-block mr-2' style={{ width: '40%' }}>
                      <input
                        className={`cw-input ${showError && !firstName ? 'invalid' : ''
                          }`}
                        placeholder='First Name'
                        value={firstName}
                        onChange={e => this.onChangeHandler(e, 'firstName')}
                      />
                    </div>
                    <div className='d-inline-block' style={{ width: '40%' }}>
                      <input
                        className={`cw-input ${showError && !lastName ? 'invalid' : ''
                          }`}
                        placeholder='Last Name'
                        value={lastName}
                        onChange={e => this.onChangeHandler(e, 'lastName')}
                      />
                    </div>
                    {showError && (!salutation || !firstName || !lastName) && (
                      <span className='invalid-text'>
                        Salutation, First Name & Last Name are required
                      </span>
                    )}
                  </div>
                </div>

                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>EMAIL ID</label>
                    <span className='star'>*</span>
                    <input
                      className={`cw-input 
                                ${(isInvalidEmail && emailId) ||
                          (showError && !emailId)
                          ? 'invalid'
                          : ''
                        }`}
                      placeholder='Email ID'
                      onChange={e => this.onChangeHandler(e, 'emailId')}
                      onBlur={this.onBlurEmailInput}
                      onFocus={this.onFocusEmailInput}
                      value={emailId}
                      disabled={this.props.isProfile}
                    />

                    {isInvalidEmail && emailId && (
                      <span className='invalid-text'>Enter valid email</span>
                    )}
                    {showError && !emailId && (
                      <span className='invalid-text'>Please enter email</span>
                    )}
                    {isEmailAlreadyRegistered && (
                      <span className='invalid-text'>
                        The email is already in use. Please use a new email.{' '}
                      </span>
                    )}
                  </div>
                </div>
                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <div className='d-inline-block' style={{ width: "60%" }}>
                      <label className='cw-input-label'>PHONE</label>
                      <span className='star'>*</span>
                    </div>
                    <div className='d-inline-block cw-label-container' style={{ width: "40%" }}>
                      <label className='cw-input-label'>LANDLINE</label>
                      <div className='cw-label-optional d-inline-block text-right'>Optional</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <div className='d-inline-block' style={{ width: "60%" }}>
                      <div
                        className='d-inline-block mr-2'
                        style={{ width: '35%' }}
                      >
                        <DropdownV2
                          key='countryCode'
                          text='title'
                          placeholder='Select country code'
                          searchable
                          options={countryCodeDropDownData}
                          invalid={showError && !countryCode}
                          onSelect={option =>
                            this.onSelect(option, 'countryCode')
                          }
                          value={countryCode ? countryCode : ''}
                          allOptions={this.props.countryCodeDropDownData}
                          onSearch={value =>
                            this.props.onCountryCodeSearch(value)
                          }
                          style={{ background: '#F6F7F5' }}
                        />
                      </div>
                      <div className='d-inline-block' style={{ width: '60%' }}>
                        <input
                          className={`cw-input 
                        ${(isInvalidMobile && mobileNumber) ||
                              (showError && !mobileNumber)
                              ? 'invalid'
                              : ''
                            }`}
                          placeholder='Phone Number'
                          onChange={e => this.onChangeHandler(e, 'mobileNumber')}
                          value={mobileNumber}
                        />
                      </div>
                    </div>
                    <div className='d-inline-block' style={{ width: "40%" }}>
                      <input
                        className={`cw-input`}
                        placeholder='Landline Number'
                        onChange={e => this.onChangeHandler(e, 'landLine')}
                        value={landLine}
                      />
                    </div>
                    <div className='col'>
                      {showError && !mobileNumber && (
                        <span className='invalid-text'>
                          Please enter phone number
                        </span>
                      )}
                      {isInvalidMobile && mobileNumber && (
                        <span className='invalid-text'>
                          Enter valid phone number
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {(!type || type === "teacher") &&
                  <>
                    <div className='row bw-spaces-input'>
                      <div className='col-12 cw-label-container'>
                        <label className='cw-input-label'>
                          CLASS/SECTION
                        </label>
                        <span className='star'>*</span>
                        {/* <div className='cw-label-optional d-inline-block text-right'>Optional</div> */}
                      </div>
                    </div>
                    {classes.map((c, index) =>
                      <>
                        <div className='row mt-1 grouped-dropdown-container' key={index}>
                          {boardDropDownData?.length > 1 && (
                            <div className='col-3 pr-0 grouped-dropdown first'>
                              <DropdownV2
                                placeholder='Board'
                                options={boardDropDownData}
                                onSelect={option => this.onSelectBoard(option, index)}
                                text='title'
                                style={{ background: '#F6F7F5' }}
                                value={c.board}
                              />

                              <div className='divider'></div>
                            </div>
                          )}
                          <div className={`${boardDropDownData?.length > 1 ? 'col-3' : 'col-4'} pl-0 pr-0 grouped-dropdown`}>
                            {this.state.classes?.length && (
                              <DropdownV2
                                placeholder='Class'
                                options={classDropDownData}
                                onSelect={option => this.onSelectClass(option, index)}
                                text='title'
                                style={{ background: '#F6F7F5' }}
                                value={c.class}
                              />
                            )}
                            <div className='divider'></div>
                          </div>
                          <div className={`${boardDropDownData?.length > 1 ? 'col-6' : 'col-8'} pl-0 pr-0 grouped-dropdown last`}>
                            <DropdownV2
                              ref={el => this.dropdown[index] = el}
                              placeholder='Sections'
                              options={this.state.sections[index]}
                              onSelect={options => this.onSelectSection(options, index)}
                              text='title'
                              style={{ background: '#F6F7F5' }}
                              value={c.sections}
                              multiSelect={true}
                            />
                          </div>
                          {index > 0 &&
                            <div className='remove-class cursor-pointer' onClick={_ => this.removeClass(index)}>
                              <img
                                src={getImageSource(ImageConstants.CROSS)}
                                className='close-icon'
                              ></img>
                            </div>
                          }
                        </div>
                      </>
                    )}
                    <div className='col'>
                     {showError && !(this.state.noSectionInClass) && !this.state.selectedSections && (
                        <span className='invalid-text mr-1'>
                          Please Select Class, Sections
                        </span>
                      )}
 

                      {/* {showError && !( selectedClass ) && (
                        <span className='invalid-text mr-1'>
                          Please Select Class
                        </span>
                      )}
                      {showError && !(selectedSections?.length) && (
                        <span className='invalid-text'>
                          Please Select Section
                        </span>
                      )} */}
                      {/* {showError && !selectedClass && (
                        <span className='invalid-text'>
                          Please Select Class
                        </span>
                      )} */}
                    </div>
                    <div className='text-right'>
                    <button className='add-new-class' onClick={this.addNewClass}>+ Add Class</button>
                  </div>
                  </>
                }
                {type === "management" &&
                  <>
                    <div className='row bw-spaces-input'>
                      <div className='col-12'>
                        <label className='cw-input-label no-padding'>
                          ROLE
                        </label>
                        <span className='star'>*</span>
                      </div>
                    </div>
                    <div className='row pt-1' >
                      <div className='col-12'>
                        <div className='pl-0 pr-0'>
                          {rolesDropDownData?.length && (
                            <DropdownV2
                              placeholder='Select role'
                              options={rolesDropDownData}
                              onSelect={option => this.onSelectRole(option, "role")}
                              text='title'
                              style={{ background: '#F6F7F5' }}
                              value={role?.value}
                              invalid={showError && (!role.title || !role.value)}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                }
                {otpSend === true && (
                  <div className='row bw-spaces-input'>
                    <div className='col'>
                      <label className='cw-input-label'>OTP</label>
                      <input
                        className={`cw-input 
                                ${isOtpSubmit && !otp ? 'invalid' : ''}`}
                        placeholder={`Enter 6 digit code sent to ${emailId}`}
                        onChange={e => this.onChangeHandler(e, 'otp')}
                        value={otp}
                      />
                      {isOtpSubmit && !otp && (
                        <span className='invalid-text'>Please enter OTP</span>
                      )}
                      {isInvalidOTP && otp && (
                        <span className='invalid-text'>
                          Please enter valid OTP
                        </span>
                      )}
                      {isExpiredOTP && otp && (
                        <span className='invalid-text'>OTP Expired</span>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
            {isSignupSuccess && (
              <div>
                <img
                  src={getImageSource(ImageConstants.SIGNUP_SUCCESS_BANNER)}
                  className='success-banner'
                ></img>
              </div>
            )}
          </div>
          {!isSignupSuccess && (
            <>
              {otpSend === false ? (
                <div
                  className={`cw-card-footer`}
                  onClick={!isSubmit && this.sendUsersSignupOTP}
                >
                  <span className='footer-text'>REGISTER</span>
                </div>
              ) : (
                <div
                  className={`cw-card-footer ${!otp &&
                    'cw-card-footer-secondary'}`}
                  onClick={otp && otp.length === 6 && this.signUp}
                >
                  {!otp && (
                    <>
                      <p className='footer-text'>
                        Enter the 6 Digit OTP we have sent to your email and
                        Mobile.
                      </p>
                      <p className='footer-text'>
                        Check your SPAM folder in case it does not show in your
                        inbox
                      </p>
                    </>
                  )}{' '}
                  {otp && <span className='footer-text'>Submit</span>}
                </div>
              )}
            </>
          )}

        </div>
        {!isSignupSuccess &&
          <div className='footer-text text-center mt-3'>
            <div>Not a Teacher from {this.props.userDetails.schoolName}?</div>
            <div className='click-here' onClick={_ => this.props.history.replace(Path.LOGIN)}>Click Here</div>
          </div>
        }
      </div>
    )
  }
}

export default SchoolUserSignUp
